/* oxlint-disable @typescript-eslint/ban-ts-comment */
import { SettingsTab } from "../components/settings/Settings"
import { API_ORIGIN } from "./constants"

type NEXT_URL =
  | ["/404"]
  | ["/admin/"]
  | ["/admin/bundles"]
  | ["/admin/finmodel"]
  | ["/admin/finmodel/failures"]
  | ["/admin/finmodel/failures/facet"]
  | ["/admin/finmodel/failures/[id]", { id: number }]
  | ["/admin/tariffs/[tariffId]", { tariffId: number }]
  | ["/admin/orgs"]
  | ["/admin/orgs/[orgPid]", { orgPid: string }]
  | ["/admin/orgs/[orgPid]/products", { orgPid: string }]
  | ["/admin/orgs/[orgPid]/products/[id]", { orgPid: string; id: number }]
  | ["/admin/portfolios"]
  | ["/admin/portfolios/[pid]", { pid: string }]
  | ["/admin/portfolios/[pid]/energy", { pid: string }]
  | ["/admin/portfolios/[pid]/energy/logins", { pid: string }]
  | [
      "/admin/portfolios/[pid]/energy/logins/[loginId]",
      { pid: string; loginId: number },
    ]
  | ["/admin/portfolios/[pid]/tasks", { pid: string }]
  | ["/admin/orgs/[pid]/physical-check", { pid: string }]
  | [
      "/admin/orgs/[pid]/physical-check?pids=[sitePids]",
      { pid: string; sitePids: string },
    ]
  | ["/admin/portfolios/[pid]/bulk", { pid: string }]
  | ["/admin/multiportfolio"]
  | ["/admin/queue"]
  | ["/admin/bulk-update"]
  | ["/admin/solar-captcha"]
  | ["/admin/batteries"]
  | ["/admin/ftm-programs"]
  | ["/admin/utilities"]
  | ["/admin/utilities/[slug]", { slug: string }]
  | ["/admin/utilities/[slug]/tariffs", { slug: string }]
  | ["/admin/sites/[sitePid]", { sitePid: string }]
  | ["/admin/sites/[sitePid]/changelog", { sitePid: string }]
  | ["/admin/sites/[sitePid]/finmodels", { sitePid: string }]
  | ["/admin/sites/[sitePid]/finmodels/[id]", { sitePid: string; id: number }]
  | [
      "/admin/sites/[sitePid]/finmodels/[a]/compare?other=[b]",
      { sitePid: string; a: number; b: number },
    ]
  | ["/admin/sites/[sitePid]/results", { sitePid: string }]
  | ["/admin/sites/[sitePid]/results/[id]", { sitePid: string; id: number }]
  | ["/admin/sites/[sitePid]/projects", { sitePid: string }]
  | ["/admin/sites/[sitePid]/etb", { sitePid: string }]
  | ["/admin/sites/[sitePid]/etb/[etbId]", { sitePid: string; etbId: string | number }]
  | ["/admin/sites/[sitePid]/bill-entry", { sitePid: string }]
  | ["/admin/sites/[sitePid]/energy", { sitePid: string }]
  | ["/admin/sites/[sitePid]/energy/conservice", { sitePid: string }]
  | ["/admin/sites/[sitePid]/energy/espm", { sitePid: string }]
  | ["/admin/sites/[sitePid]/energy/meters", { sitePid: string }]
  | ["/admin/sites/[sitePid]/energy/multi-meter", { sitePid: string }]
  | ["/admin/sites/[sitePid]/energy/multi-meter/[id]", { sitePid: string; id: number }]
  | [
      "/admin/sites/[sitePid]/energy/multi-meter/[id]/name-that-tariff",
      { sitePid: string; id: number },
    ]
  | [
      "/admin/sites/[sitePid]/energy/multi-meter/set/[id]",
      { sitePid: string; id: number },
    ]
  | ["/admin/sites/[sitePid]/helioscopes", { sitePid: string }]
  | ["/admin/sites/[sitePid]/lux/[id]", { sitePid: string; id: number }]
  | ["/admin/sites/[sitePid]/building-data", { sitePid: string }]
  | ["/admin/sites/[sitePid]/policy", { sitePid: string }]
  | ["/admin/sites/[sitePid]/scenarios", { sitePid: string }]
  | ["/admin/sites/[sitePid]/scenarios/[pid]", { sitePid: string; pid: string }]
  | ["/admin/sites/[sitePid]/status", { sitePid: string }]
  | ["/admin/sites/[sitePid]/utils/pdf-test", { sitePid: string }]
  | ["/admin/sites/[sitePid]/utils", { sitePid: string }]
  | ["/admin/sites/table"]
  | ["/admin/policies"]
  | ["/admin/policies/[pid]", { pid: string }]
  | ["/admin/users"]
  | ["/admin/users/[userId]", { userId: number }]
  | ["/admin/users/new"]
  | ["/admin/users/open-invites"]
  | ["/admin/impact"]
  | ["/admin/announcements"]
  | ["/orgs"]
  | ["/[orgSlug]", { orgSlug: string }]
  | ["/[orgSlug]/welcome", { orgSlug: string }]
  | ["/[orgSlug]/shine", { orgSlug: string }]
  | ["/[orgSlug]/properties", { orgSlug: string }]
  | ["/[orgSlug]/properties/add", { orgSlug: string }]
  | [
      "/[orgSlug]/properties/[propertyPid]/documents",
      { orgSlug: string; propertyPid: string },
    ]
  | ["/[orgSlug]/properties/[propertyPid]/ev", { orgSlug: string; propertyPid: string }]
  | [
      "/[orgSlug]/properties/[propertyPid]/solar",
      { orgSlug: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/solar/[resultPid]",
      { orgSlug: string; propertyPid: string; resultPid: string },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/property",
      { orgSlug: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/general",
      { orgSlug: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/electricity",
      { orgSlug: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/electricity/tariffs/custom/[tariffId]",
      { orgSlug: string; propertyPid: string; tariffId: number },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/configure",
      { orgSlug: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/transact",
      { orgSlug: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/shine",
      { orgSlug: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/marketplace/preparing-bid-launch",
      { orgSlug: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/marketplace/collecting-bids",
      { orgSlug: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/marketplace/reviewing-bids",
      { orgSlug: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/marketplace/negotiating-contracts",
      { orgSlug: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/marketplace/developing-project",
      { orgSlug: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/properties/[propertyPid]/marketplace/shine",
      { orgSlug: string; propertyPid: string },
    ]
  | ["/[orgSlug]/marketplace", { orgSlug: string }]
  | ["/[orgSlug]/marketplace/bids", { orgSlug: string }]
  | ["/[orgSlug]/marketplace/properties", { orgSlug: string }]
  | ["/[orgSlug]/marketplace/packages", { orgSlug: string }]
  | [
      "/[orgSlug]/marketplace/packages/[bundlePid]",
      { orgSlug: string; bundlePid: string },
    ]
  | [
      "/[orgSlug]/marketplace/packages/[bundlePid]/emails",
      { orgSlug: string; bundlePid: string },
    ]
  | [
      "/[orgSlug]/marketplace/packages/[bundlePid]/property/[propertyPid]",
      { orgSlug: string; bundlePid: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/marketplace/packages/[bundlePid]/property/[propertyPid]/bid/[bidPid]",
      { orgSlug: string; bundlePid: string; propertyPid: string; bidPid: string },
    ]
  | ["/[orgSlug]/bundles", { orgSlug: string }]
  | ["/[orgSlug]/bundles/parents", { orgSlug: string }]
  | ["/[orgSlug]/bundles/parents/[pid]", { orgSlug: string; pid: string }]
  | ["/[orgSlug]/bundles/parents/[pid]/emails", { orgSlug: string; pid: string }]
  | ["/[orgSlug]/invest", { orgSlug: string }]
  | ["/[orgSlug]/invest/origination", { orgSlug: string }]
  | [
      "/[orgSlug]/invest/origination/[bundlePid]",
      { orgSlug: string; bundlePid: string },
    ]
  | [
      "/[orgSlug]/invest/origination/[bundlePid]/reports",
      { orgSlug: string; bundlePid: string },
    ]
  | [
      "/[orgSlug]/invest/origination/[bundlePid]/property/[propertyPid]/create-bid",
      { orgSlug: string; bundlePid: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/invest/origination/[bundlePid]/property/[propertyPid]/bid/[bidPid]",
      { orgSlug: string; bundlePid: string; propertyPid: string; bidPid: string },
    ]
  | ["/[orgSlug]/invest/development", { orgSlug: string }]
  | ["/[orgSlug]/invest/[bundlePid]", { orgSlug: string; bundlePid: string }]
  | [
      "/[orgSlug]/invest/[bundlePid]/property/[propertyPid]/create-bid",
      { orgSlug: string; bundlePid: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/invest/[bundlePid]/property/[propertyPid]/create-bid/[specPid]",
      { orgSlug: string; bundlePid: string; propertyPid: string; specPid: string },
    ]
  | [
      "/[orgSlug]/invest/[bundlePid]/property/[propertyPid]/bid/[bidPid]",
      { orgSlug: string; bundlePid: string; propertyPid: string; bidPid: string },
    ]
  | [
      "/[orgSlug]/invest/development/[bundlePid]/property/[propertyPid]",
      { orgSlug: string; bundlePid: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/invest/development/[bundlePid]/property/[propertyPid]/documents",
      { orgSlug: string; bundlePid: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/invest/development/[bundlePid]/property/[propertyPid]/bids",
      { orgSlug: string; bundlePid: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/invest/[bundlePid]/property/[propertyPid]",
      { orgSlug: string; bundlePid: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/invest/[bundlePid]/property/[propertyPid]/documents",
      { orgSlug: string; bundlePid: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/invest/[bundlePid]/property/[propertyPid]/bids",
      { orgSlug: string; bundlePid: string; propertyPid: string },
    ]
  | [
      "/[orgSlug]/invest/settings?tab=[tab]",
      { tab: SettingsTab | undefined; orgSlug: string },
    ]
  | ["/[orgSlug]/invest/settings", { orgSlug: string }]
  | ["/[orgSlug]/projects", { orgSlug: string }]
  | ["/[orgSlug]/settings?tab=[tab]", { tab: SettingsTab | undefined; orgSlug: string }]
  | ["/[orgSlug]/settings", { orgSlug: string }]
  | ["/[orgSlug]/uploads", { orgSlug: string }]
  | ["/[orgSlug]/uploads/[csvImportPid]", { orgSlug: string; csvImportPid: string }]
  | [
      "/[orgSlug]/uploads/[csvImportPid]/rows/[rowId]",
      { orgSlug: string; csvImportPid: string; rowId: number },
    ]
  | ["/[orgSlug]/reonomy", { orgSlug: string }]
  | ["/pdf/portfolio-report-obbba?orgSlug=[orgSlug]", { orgSlug: string }]
  | ["/[orgSlug]/org-emails", { orgSlug: string }]
  | [
      "/pdf/report-sales?orgSlug=[orgSlug]&sitePid=[sitePid]&resultPid=[resultPid]",
      { orgSlug: string; sitePid: string; resultPid: string },
    ]
  | ["/connect/"]
  | ["/connect/[pid]", { pid: string }]
  | ["/resources/how-does-lumen-energy-evaluate-bids/"]
  | ["/login"]

type FLASK_URL =
  | ["/"]
  | ["/admin/attachments/[id]", { id: string | number }]
  | ["/dl/sample_import.csv"]
  | ["/estimates"]
  | ["/logout"]
  | ["/buildings/[sitePid]/reopt", { sitePid: string }]
  | ["/buildings/[sitePid]/reopt/[reoptPid]", { sitePid: string; reoptPid: string }]
  | [
      "/portfolio/[portfolioPid]/sites/[sitePid]/cash_flow_model",
      { portfolioPid: string; sitePid: string },
    ]
  | [
      "/offtaker/[portfolioPid]/sites/[sitePid]/cash_flow_model",
      { portfolioPid: string; sitePid: string },
    ]
  | [
      "/portfolio/[portfolioPid]/sites/[sitePid]/clean-energy-report.pdf",
      { portfolioPid: string; sitePid: string },
    ]
  | ["/sites/[sitePid]/intervals", { sitePid: string }]
  | [
      "/sites/[sitePid]/intervals?finmodel=[finmodelId]",
      { sitePid: string; finmodelId: number },
    ]
  | ["/sites/[sitePid]/intervals/[finmodelId]", { sitePid: string; finmodelId: number }]
  | ["/legal/privacy-policy"]
  | ["/legal/terms-of-service"]
  | ["/legal/terms-of-use"]
  | ["/help/product"]
  | ["/auth/google/login"]

type HELP_URL =
  | ["/resources/how-going-solar-raises-commercial-property-value"]
  | ["/resources/how-does-lumen-determine-the-optimal-amount-of-solar-for-a-building"]
  | ["/resources/net-zero-and-its-impact-on-institutional-investors"]
  | ["/resources/providing-energy-data"]
  | [
      "/resources/reduce-your-carbon-emissions-renewable-energy-vs-energy-efficiency-upgrades",
    ]
  | ["/resources/solar-financing-terms-explained"]
  | ["/resources/understanding-solar-power-purchase-agreements"]
  | [
      "/resources/unlock-the-benefits-of-solar-investment-tax-credits-for-your-commercial-real-estate-properties",
    ]
  | ["/resources/what-financing-options-are-available"]
  | ["/resources/your-guide-to-the-lumen-journey"]
  | ["/resources/your-step-by-step-guide-to-going-solar-with-ppa-financing"]
  | ["/resources/community-solar-101"]

export function url([pathname, query]: NEXT_URL): string {
  // It would be nice to return {pathname, query} URL objects as supported by `<Link>`,
  // but that breaks client-side transitions for paths like
  // /portfolio/.../{evaluate,bids,documents} which are defined with [[...params]].
  return query
    ? // @ts-ignore
      pathname.replaceAll(/\[([^\]]+)\]/g, (_, key) => encodeURIComponent(query[key]))
    : pathname
}

export function flaskUrl([pathname, query]: FLASK_URL): string {
  const url = pathname.replaceAll(
    /\[([^\]]+)\]/g,
    // @ts-ignore
    (_, key: keyof typeof query) => encodeURIComponent(query[key]),
  )
  return API_ORIGIN + url
}

export function helpUrl([pathname]: HELP_URL): string {
  const url = pathname
  return API_ORIGIN + url
}

export function hubspotRecordUrl(hubspotRecordId: string): string {
  return `https://app.hubspot.com/contacts/20832032/record/0-3/${hubspotRecordId}`
}
